/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SignUpService } from "../authServices/signup.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { SignupComponent } from "../signup/signup.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-verification",
  templateUrl: "./verification.component.html",
  styleUrls: ["./verification.component.scss"],
})
export class VerificationComponent implements OnInit {
  otp: string;
  isProd = environment.name === "production";
  isErrorVerifyngOTP = false;
  errorMessage: string;
  currentURL: string;
  isEmail: boolean;
  verificationForm = new FormGroup({
    verifyOTPControl: new FormControl("", [Validators.required]),
  });
  userSignUpResponse: any;
  constructor(
    private router: Router,
    private signUpService: SignUpService,
    private dialogVerification: MatDialogRef<VerificationComponent>
  ) {}

  ngOnInit() {
    this.currentURL = this.router.url;
    this.signUpService.singUpResponseSubject.subscribe(
      (json: any) => {
        this.userSignUpResponse = json;
        this.isEmail = this.userSignUpResponse.user.email;
        this.otp = this.userSignUpResponse.otp;
        console.log(this.userSignUpResponse);
      },
      (err) => console.log(err)
    );
  }
  verificationValidation() {
    const formOTP: any = this.verificationForm.get("verifyOTPControl").value;
    this.signUpService
      .verifyOTP({
        isverifyotp: true,
        otp: formOTP,
        username: this.userSignUpResponse.user.username,
      })
      .subscribe(
        (res: any) => {
          if (res.status === true) {
            localStorage.setItem(
              "userPic",
              this.userSignUpResponse.user.profileImageURL
            );
            localStorage.setItem(
              "nVipaniwhiteshopUser",
              this.userSignUpResponse.user.username
            );
            if (res.token) {
              localStorage.setItem("nVipaniwhiteshopkey", res.token);
            }
            this.isErrorVerifyngOTP = false;
            this.dialogVerification.close();
          } else if (formOTP === "") {
            this.isErrorVerifyngOTP = true;
            this.errorMessage = "Please enter OTP to verify";
          } else {
            this.isErrorVerifyngOTP = true;
            this.errorMessage = "OTP is not valid";
          }
        },
        (err) => {
          console.log(err.error.message);
          this.isErrorVerifyngOTP = true;
          this.errorMessage = err.error.message;
        }
      );
  }
}
